<div class="admin-container">
  <mat-toolbar class="admin-toolbar">
    <span>Gamenight Management</span>
    <span class="spacer"></span>
    <button 
      mat-raised-button 
      color="primary" 
      (click)="startCreate()"
    >
      <mat-icon>add</mat-icon>
      Add Option
    </button>
    <button 
      mat-raised-button 
      color="warn" 
      (click)="resetAllVotes()"
      [disabled]="isResetting || options.length === 0"
      style="margin-left: 8px;"
    >
      <mat-icon>{{isResetting ? 'hourglass_empty' : 'refresh'}}</mat-icon>
      {{isResetting ? 'Resetting...' : 'Reset All Votes'}}
    </button>
  </mat-toolbar>

  <!-- Statistics Card -->
  <mat-card class="stats-card">
    <mat-card-content>
      <div class="stats-grid">
        <div class="stat-item">
          <div class="stat-value">{{options.length}}</div>
          <div class="stat-label">Total Options</div>
        </div>
        <div class="stat-item">
          <div class="stat-value">{{getTotalVotes()}}</div>
          <div class="stat-label">Total Votes</div>
        </div>
        <div class="stat-item">
          <div class="stat-value">{{getActiveOptionsCount()}}</div>
          <div class="stat-label">Active Options</div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>


  <!-- Options Table -->
  <mat-card class="table-card">
    <mat-card-content>
      @if (isLoading) {
        <div class="loading-container">
          <mat-icon class="loading-icon">hourglass_empty</mat-icon>
          <p>Loading options...</p>
        </div>
      } @else if (options.length === 0) {
        <div class="empty-container">
          <mat-icon class="empty-icon">inbox</mat-icon>
          <p>No gamenight options found</p>
          <button mat-raised-button color="primary" (click)="startCreate()">
            <mat-icon>add</mat-icon>
            Create First Option
          </button>
        </div>
      } @else {
        <div class="table-container">

          <div style="display: flex; flex-direction: row; align-items: center; gap: 8px; width: 100%; justify-content: center; margin-bottom: 1rem;">
            <span style="font-size: 14px;">Finally fixed the width of those bars</span>
            <img style="height: 24px" src="/nyah.webp">
          </div>

          <table mat-table [dataSource]="options" class="options-table">
            <!-- Title Column -->
            <ng-container matColumnDef="title">
              <th mat-header-cell *matHeaderCellDef>Title</th>
              <td mat-cell *matCellDef="let option">
                <div class="option-title">
                  <img 
                    [src]="option.image_url" 
                    [alt]="option.title"
                    class="option-thumbnail"
                  >
                  <span>{{option.title}}</span>
                </div>
              </td>
            </ng-container>

            <!-- Vote Bar Column -->
            <ng-container matColumnDef="vote_bar">
              <th mat-header-cell *matHeaderCellDef>Vote Distribution</th>
              <td mat-cell *matCellDef="let option">
                <div class="vote-bar-container">
                  <div class="vote-bar">
                    <div 
                      class="vote-bar-fill" 
                      [style.width.%]="getVotePercentage(option.vote_count)"
                      [class.has-votes]="option.vote_count > 0"
                    ></div>
                  </div>
                  <span class="vote-count">{{option.vote_count}}</span>
                </div>
              </td>
            </ng-container>

            <!-- Vote Count Column -->
            <ng-container matColumnDef="vote_count">
              <th mat-header-cell *matHeaderCellDef>Votes</th>
              <td mat-cell *matCellDef="let option">
                <mat-chip-set>
                  <mat-chip [color]="option.vote_count > 0 ? 'primary' : 'default'">
                    {{option.vote_count}}
                  </mat-chip>
                </mat-chip-set>
              </td>
            </ng-container>

            <!-- Active Status Column -->
            <ng-container matColumnDef="is_active">
              <th mat-header-cell *matHeaderCellDef>Status</th>
              <td mat-cell *matCellDef="let option">
                <mat-chip-set>
                  <mat-chip [color]="option.is_active === '1' ? 'accent' : 'warn'">
                    {{option.is_active === '1' ? 'Active' : 'Inactive'}}
                  </mat-chip>
                </mat-chip-set>
              </td>
            </ng-container>

            <!-- Display Order Column -->
            <ng-container matColumnDef="display_order">
              <th mat-header-cell *matHeaderCellDef>Order</th>
              <td mat-cell *matCellDef="let option">{{option.display_order}}</td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Actions</th>
              <td mat-cell *matCellDef="let option">
                <button 
                  mat-icon-button 
                  color="primary" 
                  (click)="startEdit(option)"
                  matTooltip="Edit option"
                >
                  <mat-icon>edit</mat-icon>
                </button>
                <button 
                  mat-icon-button 
                  color="warn" 
                  (click)="deleteOption(option)"
                  matTooltip="Delete option"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.top-option]="topOptionIds.includes(row.id)"></tr>
          </table>
        </div>
      }
    </mat-card-content>
  </mat-card>
</div>
